import React from "react"
import { Box, Text } from "@chakra-ui/react"

type Props = {
  name: string
}
const MenuCategory = ({ name }: Props) => (
  <Box borderBottomWidth={1} h={10} backgroundColor="gray.100" py={2} px={6}>
    <Text fontWeight="semibold">
      {name}
    </Text>
  </Box>
)

export default MenuCategory
